export default __webpack_public_path__ + "static/media/Banner_Residencial_Desktop.bab0960d.png";